// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import ReviewSvg from '@rsuite/icon-font/lib/flow/Review';
var Review = createSvgIcon({
  as: ReviewSvg,
  ariaLabel: 'review',
  category: 'flow',
  displayName: 'Review'
});
export default Review;